export default __webpack_public_path__ + "static/purple-hatch-76a64a59d5e98cf04d1c760941aec3ba.jpg";